import styled from "@emotion/styled"
import Textfield from "../../Common/TextInput/TextInput";
import CloseIcon from "@mui/icons-material/Close";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import SearchIcon from "@mui/icons-material/Search";

export const StyledTextfieldContainer = styled(Textfield)({
  width: "100%",
  padding: "10px",
  paddingRight: "58px",
  border: "1px solid var(--border__color)",
  borderRadius: "7px",
  boxSizing: "border-box",
  outline: "none",
  transition:
    "border-color 160ms ease, box-shadow 160ms ease, background-color 160ms ease",
  "&:hover": {
    borderColor: "#6860ee",
  },
  "&:focus": {
    borderColor: "#6860ee",
    boxShadow: "0 0 0 2px rgba(104, 96, 238, 0.20)",
  },
})
export const StyledCheckContainer = styled("div")({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  minHeight: "39px",
  padding: "0 14px",
  borderTop: "1px solid var(--border__color, #e5ebf3)",
  borderBottom: "1px solid var(--border__color, #e5ebf3)",
  color: "#74839a",
  fontSize: "13px",
})

export const StyledDropdownContainer = styled("div")({
  position: "relative",
  cursor: "pointer",
  userSelect: "none",
  width: "100%",
})

export const StyledDropdownArrow = styled(ArrowDropDownIcon, {
  shouldForwardProp: (prop) => prop !== "isOpen" && prop !== "hasLabel",
})(({ isOpen, hasLabel }) => ({
  position: "absolute",
  top: hasLabel ? "calc(100% - 26px)" : "20px",
  right: "8px",
  color: "var(--header__color, #1f2937)",
  fontSize: "24px",
  pointerEvents: "none",
  transform: `translateY(-50%) rotate(${isOpen ? "180deg" : "0deg"})`,
  transition: "transform 160ms ease",
}))

export const StyledClearButton = styled("button")({
  position: "absolute",
  top: "21px",
  right: "32px",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  width: "22px",
  height: "22px",
  padding: 0,
  border: 0,
  borderRadius: "50%",
  background: "transparent",
  color: "var(--header__color, #1f2937)",
  cursor: "pointer",
  transform: "translateY(-50%)",
  "&:hover": {
    background: "rgba(104, 96, 238, 0.12)",
    color: "#6860ee",
  },
})

export const StyledClearIcon = styled(CloseIcon)({
  fontSize: "18px",
})

export const StyledDropdownMenu = styled("div")({
  position: "absolute",
  top: "calc(100% + 6px)",
  left: 0,
  display: "flex",
  flexDirection: "column",
  backgroundColor: "var(--table__background, #ffffff)",
  border: "1px solid var(--border__color, #dfe5f2)",
  boxShadow: "0 14px 28px rgba(24, 39, 75, 0.14)",
  zIndex: "99",
  width: "max(100%, 334px)",
  maxWidth: "calc(100vw - 24px)",
  maxHeight: "410px",
  overflow: "hidden",
  borderRadius: "8px",
    '&::-webkit-scrollbar': {
    width: "8px",
    height: "8px",
  },
  '&::-webkit-scrollbar-track': {
    borderRadius: "5px",
    backgroundColor: "#e6f1f5",
  },
  '&::-webkit-scrollbar-thumb': {
    borderRadius: "5px",
    backgroundColor: "#1b52a729",
  },
  '&::-webkit-scrollbar-thumb:hover': {
    backgroundColor: " #1b52a742",
  },
  '&::-webkit-scrollbar-thumb:active': {
    backgroundColor: "#1b52a740",
  },
})

export const StyledStickyContainer = styled("div")({
  flex: "0 0 auto",
  background: "var(--table__background, #ffffff)",
})
export const StyledDropdownSearchItem = styled("div")({
  padding: "12px 14px 10px",
  cursor: "pointer",
  fontSize: "14px",
})
export const StyledDropdownItem = styled("div")(({ selected }) => ({
  padding: "8px 18px",
  cursor: "pointer",
  fontSize: "14px",
  display: "flex",
  gap: "10px",
  alignItems: "center",
  minHeight: "40px",
  backgroundColor: selected ? "rgba(104, 96, 238, 0.06)" : "transparent",
  color: "var(--header__color, #1f2937)",
  "&:hover": {
    backgroundColor: "rgba(104, 96, 238, 0.08)",
  },
}));

export const StyledOptionsList = styled("div")({
  flex: "1 1 auto",
  minHeight: 0,
  overflowY: "auto",
  padding: "8px 0",
  '&::-webkit-scrollbar': {
    width: "8px",
  },
  '&::-webkit-scrollbar-track': {
    backgroundColor: "transparent",
  },
  '&::-webkit-scrollbar-thumb': {
    borderRadius: "999px",
    backgroundColor: "#c8d2df",
  },
});

export const StyledSearchWrapper = styled("div")({
  position: "relative",
});

export const StyledSearchIcon = styled(SearchIcon)({
  position: "absolute",
  left: "12px",
  top: "50%",
  transform: "translateY(-50%)",
  color: "#60708a",
  fontSize: "20px",
  pointerEvents: "none",
});

export const StyledSearchContainer = styled("input")({
  width: "100%",
  boxSizing: "border-box",
  height: "38px",
  padding: "0 12px 0 38px",
  border: "1px solid var(--border__color, #d8e0eb)",
  borderRadius: "7px",
  outline: "none",
  background: "var(--body__background, #ffffff)",
  color: "var(--header__color, #1f2937)",
  boxShadow: "0 2px 6px rgba(24, 39, 75, 0.10)",
  fontSize: "14px",
  "&::placeholder": {
    color: "#60708a",
    opacity: 1,
  },
  "&:focus": {
    borderColor: "#6860ee",
    boxShadow: "0 0 0 3px rgba(104, 96, 238, 0.14)",
  },
})

export const StyledActionButton = styled("button")({
  border: 0,
  background: "transparent",
  color: "#6860ee",
  cursor: "pointer",
  font: "inherit",
  padding: 0,
});

export const StyledSelectedCount = styled("span")({
  color: "#74839a",
  whiteSpace: "nowrap",
});

export const StyledOptionCheckbox = styled("span")(({ selected }) => ({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  flex: "0 0 auto",
  position: "relative",
  width: "16px",
  height: "16px",
  border: `1px solid ${selected ? "#6860ee" : "#847dff"}`,
  borderRadius: "4px",
  background: selected ? "#6860ee" : "transparent",
  "&::after": selected
    ? {
        content: '""',
        width: "7px",
        height: "4px",
        borderLeft: "2px solid #ffffff",
        borderBottom: "2px solid #ffffff",
        transform: "rotate(-45deg) translate(1px, -1px)",
      }
    : {},
}));

export const StyledOptionAvatar = styled("span")(({ color }) => ({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  flex: "0 0 auto",
  width: "24px",
  height: "24px",
  borderRadius: "50%",
  background: color,
  color: "#ffffff",
  fontSize: "11px",
  fontWeight: 700,
  lineHeight: 1,
}));

export const StyledOptionLabel = styled("span")({
  overflow: "hidden",
  minWidth: 0,
  color: "var(--header__color, #1f2937)",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
});

export const StyledEmptyState = styled("div")({
  padding: "18px",
  color: "#74839a",
  fontSize: "13px",
  textAlign: "center",
});

export const StyledFooter = styled("div")({
  display: "flex",
  justifyContent: "flex-end",
  flex: "0 0 auto",
  padding: "12px 20px",
  borderTop: "1px solid var(--border__color, #e5ebf3)",
  background: "var(--table__background, #ffffff)",
});

export const StyledDoneButton = styled(StyledActionButton)({
  color: "var(--header__color, #1f2937)",
});
